import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../context/NavigationContext";
import EditChannelProvider, { EditChannelContext } from "../../context/EditChannelContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useAuth } from "../../context/AuthContext";
import { useContext, useEffect, useState } from "react";
import { ChannelState, ChannelSubstate, getChannelEditStatusString, getChannelStatusString } from "../../models/SKChannel";
import { CreateArtifactContext } from "../../context/CreateArtifactContext";

{
  /* <Layout navProps={{backArrow: false, title: '', filterOption: false, nextAction: '', onBack: () => {}, onFilter: () => {}, onNext: () => {}}} /> */
}

interface EditChannelLayoutProps {
  children?: React.ReactNode;
}

const EditChannelContextLayout = ({ children }: EditChannelLayoutProps) => {
  const navContext = useNavigationBar();
  const {
    backArrow,
    title,
    subtitle,
    buttonTitle,
    enableLink,
    filterOption,
    onActionItemSelect,
    getActionItems,
    onBack,
    onClose,
    onFilter,
    onNext,
    onEdit,
  } = navContext.navProps;

  return (
    <div>
      <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
        onBack={onBack}
        onFilter={onFilter}
        onNext={onNext}
        onClose={onClose}
        onEdit={onEdit}
        onActionItemSelect={onActionItemSelect}
        getActionItems={getActionItems}
      />

      <div className="left-0 flex flex-col w-full h-[calc(100vh-200px)] overflow-y-auto top-[84px] ">
        <ChannelStatus />
        <Outlet />
      </div>
    </div>
  );
};

const ChannelStatus = () => {
  const { channelEditData, originalState } = useContext(EditChannelContext);
  const [hideStatus, setHideStatus] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/onboarding")) {
      setHideStatus(false);
    }
  }, [location]);

  return (
    <>
      {hideStatus && (
        <div className={`flex items-center justify-end p-[3px] pr-3 !bg-[#FFCC00] h-[28px] mb-[35px]} `}>
          <div className="flex items-center gap-1">
            <p className="ml-1 capitalize">
              {originalState
                ? getChannelEditStatusString(originalState?.subStatus)
                : getChannelStatusString(channelEditData.status, channelEditData.subStatus, true)}
            </p>
            {/* {!isEdit && channelData.status === ChannelState.ACTIVE && (
              <span>
                <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
              </span>
            )} */}
          </div>
        </div>
      )}
    </>
  );
};

export default EditChannelContextLayout;
